import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ssn'
})

export class SSNPipe implements PipeTransform {
  transform(value: any) {
    let disableSearchBtn: boolean;
    if (value.length === 11) {
      disableSearchBtn = false;
    } else {
      disableSearchBtn = true;
    }
    let val = value.replace(/\D/g, '');
    let newVal = '';
    if (val.length > 4) {
      value = val;
    }
    if ((val.length > 3) && (val.length < 6)) {
      newVal += val.substr(0, 3) + '-';
      val = val.substr(3);
    }
    if (val.length > 5) {
      newVal += val.substr(0, 3) + '-';
      newVal += val.substr(3, 2) + '-';
      val = val.substr(5);
    }
    newVal += val;
    value = newVal.substring(0, 11);
    return { maskedValue: value, buttonDisability: disableSearchBtn };
  }
}
